import { Tooltip } from "@mui/material";
import LockResetIcon from '@mui/icons-material/LockReset';
import EditIcon from '@mui/icons-material/Edit';
import LoopOutlinedIcon from '@mui/icons-material/LoopOutlined';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import { openDialogUser } from "../../redux/reducers/dialogUser-reducer";
import { useDispatch, useSelector } from "react-redux";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { policies as permessi } from "../../const/policies"; 


const ButtonBoxUsers = ({ rowId, rowInfo }) => {
 
  const state = useSelector((state) => state.userDate);
  const { policies } = state;
  const dispatch = useDispatch();
  
  const handleDialogToEdit = ({dialogType, rowInfo}) => {
    dispatch(openDialogUser({dialogType, rowInfo}));
  };

  return (
    <>
        {policies.indexOf(permessi.utentiInserimentoModifica) != -1 && (
            <GridActionsCellItem
                icon={
                    <Tooltip title="Modifica" arrow>
                        <EditIcon color="primary" />
                    </Tooltip>
                }
                label="Modifica"
                onClick={() => handleDialogToEdit({dialogType:"edit", rowInfo})}
            />
        )}
        {policies.indexOf(permessi.utentiResetPassword) != -1 && (
            <GridActionsCellItem
                icon={
                    <Tooltip title="Reset Password" arrow>
                        <LockResetIcon color="primary" />
                    </Tooltip> 
                }
                label="Cancella"
                onClick={() => handleDialogToEdit({dialogType:"reset", rowInfo})}
            />
        )}
        {policies.indexOf(permessi.utentiEliminazioneRipristino) != -1 && (
            <GridActionsCellItem
                icon={
                    <Tooltip title={rowInfo.deleted ? "Abilita" : "Disabilita"} arrow>
                        { rowInfo.deleted ? <LoopOutlinedIcon color="primary" /> : <DoDisturbIcon color="primary" /> }
                    </Tooltip> 
                }
                label="Cancella"
                onClick={() => handleDialogToEdit({dialogType:"delete", rowInfo})}
            />
        )}        
    </>
  );
};

export default ButtonBoxUsers;
